// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as ColumnComponent} from './Column.svg';

import Icon, { TIconProps } from '../Icon';

export const IconColumn = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <ColumnComponent/>
  </Icon>
));
